      import React from 'react';
import DataTable from './DataTable/Table';
import { useState,useEffect } from 'react';
import userService from '../../app/services/user.service';

const VideoSolutionLink = () => {
  const [data,setData]=useState([])
  const [loading,setLoading]=useState(false)




  const headers = [
    { name: "S.No.", field: "id", sortable: true },
    { name: "QID", field: "qid", sortable: true },
    { name: "subject", field: "sub_name", sortable: true },
    { name: "Section", field: "sec_id", sortable: true },
    { name: "Display No", field: "display_number", sortable: true },
    // { name: "Link", field: "Link", sortable: true },
    { name: "Video Cript Link", field: "video_cript_id", sortable: true },
    { name: "Action", field: "action", sortable: true },
  ];
  return (
    <div>
       <DataTable
      noDataShow={true}
      headerdata={headers}
      data={data}
      type={"solution_link"}
      />
    </div>
  )
}

export default VideoSolutionLink
